var map = {
	"./legend_xa_dark_vertical.png": "oxTJ",
	"./legend_xa_english_dark_vertical.png": "PoPW",
	"./legend_xa_english_vertical.png": "67TI",
	"./legend_xa_spanish_dark_vertical.png": "UJzI",
	"./legend_xa_spanish_vertical.png": "wdY6",
	"./legend_xa_vertical.png": "4Dgi"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "J252";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/legend_xa.*_vertical\.png$
// module id = J252
// module chunks = 94